//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getSearchArticlesDownloads from '~/gql/getSearchArticlesDownloads.js'

export default {
  data() {
    return {
      articlesToShow: 2,
      downloadsToShow: 6,
      isMobile: false,
      articles: [],
      downloads: [],
      notFound: null,
      searchTerm: '',
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-hear-02.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-connect-08.svg?data`),
          width: 184,
          height: 151,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 152,
          height: 113,
          alt: '',
        },
        {
          number: 5,
          src: require(`~/assets/img/element-hear-02.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
      ],
    }
  },
  computed: {
    visibleArticles() {
      return this.articles.slice(0, this.articlesToShow)
    },
    canShowMoreArticles() {
      return this.articlesToShow < this.articles.length
    },
    visibleDownloads() {
      return this.downloads.slice(0, this.downloadsToShow)
    },
    canShowMoreDownloads() {
      return this.downloadsToShow < this.downloads.length
    },
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
  watch: {
    '$route.query.q'(newQuery) {
      this.searchTerm = newQuery || ''
      if (this.searchTerm) {
        this.fetchArticles()
      }
    },
  },
  mounted() {
    this.searchTerm = this.$route.query.q || ''
    if (this.searchTerm) {
      this.fetchArticles()
    }
    this.updateArticlesToShow()
    this.updateDownloadsToShow()
    window.addEventListener('resize', this.updateArticlesToShow)
    window.addEventListener('resize', this.updateDownloadsToShow)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateArticlesToShow)
    window.removeEventListener('resize', this.updateDownloadsToShow)
  },
  methods: {
    async fetchArticles() {
      try {
        const { articles, download } = await this.$graphcms.request(
          getSearchArticlesDownloads,
          {
            search: this.searchTerm,
            lang: [this.$i18n.locale],
            assetLocales: [this.$i18n.locale, this.$i18n.defaultLocale],
          }
        )
        let downloadsFiltered = []
        if (articles) this.articles = articles
        if (download) {
          downloadsFiltered = download.items.filter(
            (item) =>
              item.title
                .toLowerCase()
                .includes(this.searchTerm.toLowerCase()) ||
              item.text.toLowerCase().includes(this.searchTerm.toLowerCase())
          )
          this.downloads = downloadsFiltered
        }
        this.notFound = articles.length === 0 && downloadsFiltered.length === 0
      } catch (error) {
        console.error(error)
        this.notFound = true
      }
    },
    showMoreArticles() {
      this.articlesToShow += 2
    },
    updateArticlesToShow() {
      this.isMobile = window.innerWidth <= 768
      this.articlesToShow = 2
    },
    showMoreDownloads() {
      this.downloadsToShow += this.isMobile ? 3 : 6
    },
    updateDownloadsToShow() {
      this.isMobile = window.innerWidth <= 768
      this.downloadsToShow = this.isMobile ? 3 : 6
    },
  },
}
